import React, { useContext } from 'react';
import classNames from 'classnames';
import { ListingCreationStepperProps } from '../ListingCreationStepper/ListingCreationStepper.component';
import { t } from 'i18next';
import StepsContext from 'providers/Steps/Steps.context';

import './CircleStepper.styles.scss';
import './CircleStepper.styles.responsive.scss';

const CircleStepper: React.FC<ListingCreationStepperProps> = (props) => {
  const { className } = props;

  const { currentStep, steps } = useContext(StepsContext);

  const classes = classNames('circle-stepper', className);

  return (
    <div className={classes}>
      <div
        className="circle-stepper__container"
        style={{
          background: `conic-gradient(blue ${
            ((currentStep + 1) * 360) / steps.length
          }deg, white 0)`,
        }}
      >
        <div className="circle-stepper__fill"></div>
        <p>{currentStep + 1}</p>
      </div>

      <div className="circle-stepper__labels">
        <p>{`${t('step')} ${currentStep + 1}/${steps.length}`}</p>
        <p>{t(steps[currentStep]?.labelId)}</p>
      </div>
    </div>
  );
};

export default CircleStepper;
